import "../../SharedComponents/Styles/SharedGenericStyles.css";

export const Button = ({ label, handleClick, type = "button" }) => {
  return (
    <button onClick={handleClick} type={type}>
      <b>{label}</b>
    </button>
  );
};
